/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu'
import { LinqService, QueryOptions } from 'linquest'
import { ArticleCategoryDto, ArticleCategoryTranslatedDto } from './models'

/**
 * ArticleCategoryApi - API class
 */
export class ArticleCategoryApi extends LinqService {
  /**
   * Creates a new ArticleCategoryApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider)
  }

  /**
   * @param dto
   */
  addOrUpdateAsync(dto?: ArticleCategoryDto, options?: QueryOptions) {
    const url = `/ArticleCategory/AddOrUpdateAsync`
    let query = this.createQuery<any>(url)
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}
    options.data = dto
    query = query.withOptions(options)
    return query.firstAsync()
  }

  /**
   * @param id
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    const url = `/ArticleCategory/DeleteAsync`
    let query = this.createQuery<any>(url)
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)
    return query.firstAsync()
  }

  /**
   */
  getArticleCategoryList(options?: QueryOptions) {
    // create query
    const url = `/ArticleCategory/GetArticleCategoryList`
    let query = this.createQuery<ArticleCategoryDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   * @param id
   */
  getAsync(id?: string, options?: QueryOptions) {
    const url = `/ArticleCategory/GetAsync`
    let query = this.createQuery<ArticleCategoryDto>(url)
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)
    return query.firstAsync()
  }

  /**
   * @param id
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ArticleCategory/GetTranslatedAsync`
    let query = this.createQuery<ArticleCategoryTranslatedDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   */
  list(options?: QueryOptions) {
    const url = `/ArticleCategory/List`
    let query = this.createQuery<ArticleCategoryDto>(url)
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}
    query = query.withOptions(options)
    return query
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/ArticleCategory/ListTranslated`
    let query = this.createQuery<ArticleCategoryTranslatedDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   * @param dto
   */
  saveAsync(dto?: ArticleCategoryDto, options?: QueryOptions) {
    // create query
    const url = `/ArticleCategory/SaveAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }
}
